import { type SnackbarMessage } from "@/types/types";

export const showSnackbar = (message: SnackbarMessage) => {
  const event = new CustomEvent<SnackbarMessage>("snackbarmessageopen", {
    detail: message,
  });

  window.dispatchEvent(event);
};
